module.exports = __webpack_public_path__ + "img/1a5fb72a90c5436ac32a66a7871f95df.png";